import { shadcn } from "@clerk/themes";

export const basePath = import.meta.env.BASE_URL.replace(/\/$/, "");

export function stripBase(path: string): string {
  return basePath && path.startsWith(basePath)
    ? path.slice(basePath.length) || "/"
    : path;
}

export const clerkAppearance = {
  theme: shadcn,
  cssLayerName: "clerk",
  options: {
    logoPlacement: "inside" as const,
    logoLinkUrl: basePath || "/",
    logoImageUrl: `${typeof window !== "undefined" ? window.location.origin : ""}${basePath}/logo.svg`,
  },
  variables: {
    colorPrimary: "hsl(245 75% 56%)",
    colorForeground: "hsl(220 15% 11%)",
    colorMutedForeground: "hsl(220 10% 38%)",
    colorDanger: "hsl(0 75% 55%)",
    colorBackground: "hsl(42 30% 99%)",
    colorInput: "hsl(42 30% 96%)",
    colorInputForeground: "hsl(220 15% 11%)",
    colorNeutral: "hsl(220 15% 11%)",
    fontFamily: "'Inter Tight', ui-sans-serif, system-ui, sans-serif",
    borderRadius: "0.5rem",
  },
  elements: {
    rootBox: "w-full flex justify-center",
    cardBox: "bg-background border border-border shadow-2xl rounded-2xl w-[440px] max-w-full overflow-hidden",
    card: "!shadow-none !border-0 !bg-transparent !rounded-none px-2",
    footer: "!shadow-none !border-0 !bg-transparent !rounded-none",
    logoBox: "h-12 mx-auto",
    logoImage: "h-12 w-auto",
    headerTitle: "font-display text-3xl font-bold tracking-tight text-foreground",
    headerSubtitle: "text-muted-foreground",
    socialButtonsBlockButton:
      "border border-border bg-background hover:bg-muted text-foreground rounded-full h-11 transition-colors",
    socialButtonsBlockButtonText: "font-medium text-foreground",
    dividerLine: "bg-border",
    dividerText: "font-mono text-[10px] uppercase tracking-widest text-muted-foreground",
    formFieldLabel: "font-mono text-[10px] uppercase tracking-widest text-muted-foreground",
    formFieldInput:
      "h-11 rounded-md border border-border bg-card text-foreground focus:border-primary focus:ring-2 focus:ring-primary/20",
    formButtonPrimary:
      "h-11 rounded-full bg-primary hover:bg-primary/90 text-primary-foreground font-bold uppercase tracking-wider text-xs shadow-sm transition-transform hover:-translate-y-0.5",
    footerAction: "text-center",
    footerActionText: "text-sm text-muted-foreground",
    footerActionLink: "font-bold text-primary hover:underline underline-offset-4",
    identityPreviewEditButton: "text-primary hover:underline",
    formFieldSuccessText: "text-primary text-sm",
    alert: "rounded-md border border-destructive/30 bg-destructive/10 px-3 py-2",
    alertText: "text-destructive text-sm",
    otpCodeFieldInput: "h-12 w-12 rounded-md border border-border bg-card text-foreground text-lg font-bold",
    formFieldRow: "space-y-1.5",
    main: "gap-5",
  },
};

export const clerkLocalization = {
  signIn: {
    start: {
      title: "Welcome back",
      subtitle: "Sign in to access your courses",
    },
  },
  signUp: {
    start: {
      title: "Join MainLoop",
      subtitle: "Create your student account in seconds",
    },
  },
};
